module.exports = "<button ng-if=status type=button class=\"btn btn-sm btn-success btn-icon check-avail-btn mr5\"> <i class=\"fa fa-check mr5\"></i><span translate>Twinfield: online</span> </button> <button ng-if=!status type=button class=\"btn btn-sm btn-warning btn-icon check-avail-btn mr5\" ng-click=$ctrl.authenticateTwinfield()> <i class=\"fa fa-exclamation-triangle mr5\"></i><span translate>Twinfield: koppelen</span> </button>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/twinfield.html
// module id = 387
// module chunks = 0